import React,{Component} from 'react';
import Wait from '@react/react-spectrum/Wait';

class Loader extends Component{

    render(){
        return(
            <div data-am-id="loader">
                <Wait centered size={this.props.loaderSize}/>
            </div>
        )
    }
}

export default Loader;
